import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import RateSysAdmin_nav from './RateSysAdmin_nav';

const ADMIN_LVL_MASTER = 0;				// same as Users.js

class RateSysAdminParams extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    	nbPlayers: 0,
    	nbFormEntries: 0,
			rateSysDivOption: false,
			playersByDivision: false,
			committeeVotes: false,
			elTrophyVotes: false
		};
		
		this.handleSaveParams = this.handleSaveParams.bind(this);
		this.handleCompileResultsClick = this.handleCompileResultsClick.bind(this);
		this.handlePlayersByDivisionCheckbox = this.handlePlayersByDivisionCheckbox.bind(this);
		this.handleCommitteeVotesCheckbox = this.handleCommitteeVotesCheckbox.bind(this);
		this.handleElTrophyVotesCheckbox = this.handleElTrophyVotesCheckbox.bind(this);
		this.handleImportPlayersClick = this.handleImportPlayersClick.bind(this);
	}

  componentDidMount() {
		//console.log('RateSysAdminParams: componentDidMount');
		this.loadData();
	}

  componentDidUpdate(prevProps) {
  	//console.log('RateSysAdminParams: componentDidUpdate')
  	if (!this.props.bRateSysExists) {
  		const path = './home';
			this.props.history.push(path);
		} else if (this.props.season._id !== prevProps.season._id) {
			this.loadData();
	  }
  }

	loadData() {
  	//console.log('RateSysAdminParams: loadData')
  	//console.log('_this.props.season._id: ' + this.props.season._id)

		var _this = this;
		if (_this.props.season._id !== undefined) {
	    Axios.get('/api/ratesys/getRateSys/global/' + _this.props.season._id).then(function (responseRateSys) {
    	Axios.get('/api/ratesys/nbRespondents/seasonId/' + _this.props.season._id + '/division/ALL').then(function (responseNbResp) {

    		//console.log('responseNbResp.data')
    		//console.log(responseNbResp.data)

  	  	// Rating System Divisions check
  	  	var rateSysDivOption = false;
  	  	if (_this.props.season.subSeasons[0].divisions.length > 1) {
  	  		rateSysDivOption = true;
  	  	}

	    	var rateSys = responseRateSys.data;
				_this.setState({
					nbPlayers: rateSys.players.length,
					nbFormEntries: responseNbResp.data.rateSysNbRespondents,	// ALL div here
					rateSysDivOption: rateSysDivOption,
					playersByDivision: rateSys.playersByDivision,
					committeeVotes: rateSys.committeeVotes,
					elTrophyVotes: rateSys.elTrophyVotes
				});
			});		
			});		
	  }
	}

	render() {
		//console.log('RateSysAdminParams: render');
		//console.log(this.props);

    return (
      <div>

      <div className="row">
      <div className="col-md-12">
      	<h5>Système de cotation</h5>
      </div>
      </div>

    	<RateSysAdmin_nav adminAccess={this.props.adminAccess} season={this.props.season} bRateSysExists={this.props.bRateSysExists} />

      <div className="row">
      <div className="col-md-12">
      	<h5>Stats</h5>
      </div>
      </div>

      <div className="row">
	    <div className="row col-md-12 col-xs-12">
				<ul>
					<li>Nombre de joueurs: {this.state.nbPlayers}</li>
					<li>Nombre de formulaires: {this.state.nbFormEntries}</li>
			</ul>
      </div>
      </div>
      <hr/>

      <div className="row">
      <div className="col-md-12">
      	<h5>Paramètres</h5>
      </div>
      </div>

			<div className="row row-margin-bottom-10">
	      {this.state.rateSysDivOption ? 
				<div className="col-md-3 col-12">
					<h6>Divisions</h6>
					<p>Cette saison contient des divisions dans la première sous-saison, cocher la case pour séparer les joueurs par division.</p>

					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.playersByDivision || false} onChange={this.handlePlayersByDivisionCheckbox}/>								
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;Joueurs par division

        </div>
        : null}

				<div className="col-md-3 col-12">
					<h6>Comité</h6>
					<p>Activer cette option pour afficher une section "Votes de Comité" dans le formulaire de cotation.</p>

					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.committeeVotes || false} onChange={this.handleCommitteeVotesCheckbox}/>								
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;Votes de comité
        </div>

				<div className="col-md-3 col-12">
					<h6>Trophée Éric Lavoie</h6>
					<p>Activer cette option pour afficher une section "Votes pour le Trophée Éric Lavoie" dans le formulaire de cotation.</p>

					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.elTrophyVotes || false} onChange={this.handleElTrophyVotesCheckbox}/>								
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;Votes pour le Trophée Éric Lavoie
        </div>
      </div>


			<div className="row">
			<div className="col-md-12">
				<button type="button" className="btn btn-primary" onClick={this.handleSaveParams}>
					Sauvegarder les paramètres</button>
    	</div>
    	</div>
      <hr/>

      <div className="row">
      <div className="col-md-12">
      	<h5>Actions</h5>
      </div>
      </div>

	    <div className="row">
			<div className="col-md-12">
				<button type="button" className="btn btn-primary width175px btn-margin-right-20" onClick={this.handleImportPlayersClick}>
					Importer les joueurs</button>
				<p>Doit être fait lors de la création du système de cotation (détruit l'ancienne liste de joueurs)</p>
    	</div>
    	</div>
    	<br/>

			<div className="row">
			<div className="col-md-12">
				<button type="button" className="btn btn-primary width175px" onClick={this.handleCompileResultsClick}>
					Compiler les résultats</button>
				<p>Déjà fait lorsqu'un formulaire est soumis</p>
    	</div>
    	</div>

      <hr/>


      </div>
	  );
  }

  handlePlayersByDivisionCheckbox(e) {
		this.setState({
			playersByDivision: e.target.checked
		});
  }
  handleCommitteeVotesCheckbox(e) {
		this.setState({
			committeeVotes: e.target.checked
		});
  }
  handleElTrophyVotesCheckbox(e) {
		this.setState({
			elTrophyVotes: e.target.checked
		});
  }
	
	handleSaveParams() {
		//console.log('handleSaveParams');
		var _this = this;

		var params = {
			playersByDivision: this.state.playersByDivision,
			committeeVotes: this.state.committeeVotes,
			elTrophyVotes: this.state.elTrophyVotes
		};

		Axios.post('/api/rateSys/setParams/', {
			seasonId: _this.props.season._id,
			params: params
		})
		.then(function(response) {

		})
		.catch(function(error) {
			console.log('error');
			console.log(error);
		});
  }

	handleImportPlayersClick() {
		//console.log('handleImportPlayersClick');
		var _this = this;

		Axios.post('/api/rateSys/importPlayers/', {
			seasonId: _this.props.season._id,
		})
		.then(function(response) {
			_this.loadData()
		})
		.catch(function(error) {
			console.log('error');
			console.log(error);
		});
  }

	handleCompileResultsClick() {
		//console.log('handleCompileResultsClick');
		var _this = this;

		Axios.post('/api/rateSys/compileResults/', {
			seasonId: _this.props.season._id,
		})
		.then(function(response) {

			/*
			if (response.data.msg === "OK") {
				alert("Système de cotation créé avec succès")
				_this.props.reloadSeason();
			}
			if (response.data.msg === "xxxxxx") {
				alert("Système de cotation déjà existant pour cette saison")
			}
			*/
		})
		.catch(function(error) {
			console.log('error');
			console.log(error);
		});
  }

}

export default RateSysAdminParams;

